import {BaseModel} from "@/model/Model";
import CompanyBook from "@/model/CompanyBook";
import DingtalkTask from "@/model/DingtalkTask";
import User from "@/model/User";

export class CompanyBookTaskItem extends BaseModel<CompanyBookTask> {
    user: User = new User()
}

export enum CompanyBookTaskType {
    RENTAL_OVERDUE_REMIND = "RENTAL_OVERDUE_REMIND"
}

export default class CompanyBookTask extends BaseModel<CompanyBookTask> {
    companyBook: CompanyBook = new CompanyBook()
    dingtalkTask: DingtalkTask = new DingtalkTask()

    name!: string
    type!: CompanyBookTaskType
    items: Array<CompanyBookTaskItem> = []
}
